import "./styles/tailwind.css";
import "plyr/dist/plyr.css";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import App from "./components/App";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import getEnvEndpoints from "./utils/endpoints";
import ScrollToTop from "./components/common/ScrollToTop";
import { Helmet } from "react-helmet";

const endpoints = getEnvEndpoints();

const baseUrl = document.getElementsByTagName("base")[0]?.getAttribute("href");
const rootElement = document.getElementById("root");

window.insight = new ApplicationInsights({
  config: {
    instrumentationKey: endpoints.appInsightsKey,
  },
});
window.insight.loadAppInsights();

ReactDOM.render(
  <>
    <Helmet
      script={
        endpoints.legacyAdobeEnabled === "true"
          ? [
            {
              src: endpoints.adobeLegacySrcURL,
              type: "text/javascript",
              async: true,
            },
          ]
          :
          [
            {
              src: endpoints.adobeSrcURL,
              type: "text/javascript",
              async: true,
            },
            {
              src: endpoints.adobeDataLayerURL,
              type: "text/javascript",
            },
            {
              src: endpoints.adobeEventListenerURL,
              type: "text/javascript",
            },
          ]
      }
    />
    <BrowserRouter basename={baseUrl}>
      <ScrollToTop />
      <App />
    </BrowserRouter>
  </>,
  rootElement
);
